export default "__VITE_ASSET__DD87qzfW__"